import React from 'react'

export default function AnonymousUser() {
  return (
    <div>
      <h2>Please Login First</h2>
      <img className="login" src="https://img.itch.zone/aW1nLzE1NDEyMDIuZ2lm/original/MHEFCW.gif" alt="not login"></img>
    </div>
  )
}
